import styled from '@emotion/styled';

const ModalBody = styled.div`
  width: 100%;
  height: 400px;
  overflow-y: auto;
`;

const EmptyContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .icon {
    font-size: 80px;
    color: #ccc;
  }
`;

const WaitingList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
`;

const WaitingItem = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-radius: 4px;
  padding: 10px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
`;

const WaitingItemTitle = styled.strong`
  grid-column: 1 / 3;
`;

const WaitingItemContent = styled.span``;

export {
  EmptyContent,
  ModalBody,
  WaitingItem,
  WaitingItemContent,
  WaitingItemTitle,
  WaitingList,
};
